export const voiceAgentSliceName = 'voiceAgent';
